import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'
import Topbar from './Topbar'
import VirginTopbar from './VirginTopbar'
import BookingEngineTopbar from './BookingEngineTopbar'
// TODO: tests
const TopbarPicker = () => {
  const defaultProperties = useDefaultProperties()

  if (defaultProperties?.agentConfiguration?.handlerKey === 'virgin') {
    return <VirginTopbar />
  }

  if (defaultProperties?.agentConfiguration?.isBookingEngine) {
    return <BookingEngineTopbar />
  }

  return <Topbar />
}

export default TopbarPicker
